module.exports = __webpack_public_path__ + "static/media/innovation-icon.547f69d5.svg";